import React from "react";
import { BookOpen } from "lucide-react";

interface NodeDocsButtonProps {
  nodeType: string;
}

const NodeDocsButton: React.FC<NodeDocsButtonProps> = ({ nodeType }) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    window.open(`/docs/${nodeType}`, "_blank");
  };

  return (
    <button
      onClick={handleClick}
      className="flex items-center justify-center w-7 h-7 rounded-lg bg-indigo-50 text-indigo-600 hover:bg-indigo-200 hover:text-indigo-600 transition-all duration-300 shadow-sm hover:shadow-indigo-200"
      title="Open Documentation"
    >
      <BookOpen className="w-3.5 h-3.5" />
    </button>
  );
};

export default NodeDocsButton;
